/* eslint-disable import/prefer-default-export */
/* eslint-disable consistent-return */
import createFetch from '../createFetch';
import { authorizeRequest } from '../service/auth';
import callback from './callback';

/**
 * Get Order Price
 * @param {Object} data
 * @param {String} data.nickname
 * @param {Object} data.order_request_detail_attributes
 * @param {String} data.phone_number
 * @param {String} data.pickup_time
 * @param {String} data.service_type
 * @param {String} data.vehicle
 * @param {Array} data.waypoints_attributes
 * @param {String} data.waypoints_attributes.address
 * @param {Number} data.waypoints_attributes.lat
 * @param {Number} data.waypoints_attributes.lon
 */
export async function getOrderPrice(data, locale) {
  const url = '/api/w1/utils/price_breakdown.json';

  const json = {
    order: data,
  };

  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Get All Order for a user
 * @param {String} id
 */
export async function getOrderRequest(id, locale) {
  let url = '/api/w1/order_requests.json';
  if (id !== null) {
    url = `/api/w1/order_requests/${id.toString()}.json`;
  }
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'GET',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return e;
  }
}

/**
 * Cancel order
 * @param  {Number}   id
 */
export async function cancelOrder(id, locale) {
  const url = `/api/w1/order_requests/${id}/cancel.json`;
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
  };
  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Get order breakdown
 * @param  {Number}   id
 */
export async function getOrderBreakdown(id, locale) {
  const url = `/api/w1/order_requests/${id}/breakdown.json`;
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'GET',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
  };
  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Rate Driver
 * @param  {Number}   orderNumber
 * @param  {Object}   param
 * @param  {Number}   param.driver_rating
 * @param  {String}   param.client_feedback
 * @param  {Function} callback
 * @return {ApiClient}
 */
export async function rateDriver(orderNumber, data, locale) {
  const url = `/api/w1/order_requests/${orderNumber}/rate.json`;
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  try {
    await createFetch(Options)(url, options)
      .then(result =>
        callback(null, result.body, result.status, result.headers),
      )
      .catch(error => {
        console.warn('Request failed', error);
        return error;
      });
  } catch (e) {
    return console.warn(e);
  }
  return null;
}

/**
 * submit feedback
 * @param  {Number}   orderNumber
 * @param  {String}   name
 * @param  {String}   contact
 * @param  {String}   feedbacks
 */

export async function feedback(orderNumber, name, contact, feedbacks, locale) {
  const url = `/api/w1/feedbacks.json`;

  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      order_request_id: orderNumber,
      name,
      contact,
      feedback: feedbacks,
    }),
  };
  try {
    await createFetch(Options)(url, options)
      .then(result =>
        callback(null, result.body, result.status, result.headers),
      )
      .catch(error => {
        console.warn('Request failed', error);
        return error;
      });
  } catch (e) {
    return console.warn(e);
  }
  return null;
}

/**
 * Set blacklist
 * @param  {Number}  id
 * @param  {Function} callback
 * @return {ApiClient}
 */
export async function setBlacklist(id, locale, callbackfn, callbackparam) {
  const url = `/api/w1/driver_blacklists.json`;

  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ driver_blacklist: { driver_id: id } }),
  };
  try {
    await createFetch(Options)(url, options)
      .then(result => {
        if (callbackfn) {
          setTimeout(() => {
            callbackfn(locale, callbackparam);
          }, 300);
        }
        return callback(null, result.body, result.status, result.headers);
      })
      .catch(error => {
        console.warn('Request failed', error);
        return error;
      });
  } catch (e) {
    return console.warn(e);
  }
  return null;
}

/**
 * Get blacklist
 * @param  {Function} fn
 */
export async function getBlacklist(locale, fn) {
  const url = `/api/w1/driver_blacklists.json`;

  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'GET',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
  };
  try {
    await createFetch(Options)(url, options)
      .then(result => {
        let body = null;
        if (result.status !== 404 && result.status !== 401) {
          result.json().then(b => {
            body = b;
            if (fn) {
              fn(callback(null, body, result.status, result.headers));
            }
          });
        } else {
          callback(null, body, result.status, result.headers);
        }
      })
      .catch(error => error);
  } catch (e) {
    return console.warn(e);
  }
  return null;
}

/**
 * Delete blacklist
 * @param  {Number}   blacklist id - return from driver_blacklists.json
 * @param  {Function} callbackfn
 * @return {ApiClient}
 */
export async function deleteBlacklist(id, locale, callbackfn, callbackparam) {
  const url = `/api/w1/driver_blacklists/${id}.json`;

  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'DELETE',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
  };
  try {
    /* eslint-disable no-unused-vars */
    await createFetch(Options)(url, options)
      .then(result => {
        // Delay the action of getting blacklist after delete driver in blacklist
        // you may need the result
        if (callbackfn) {
          setTimeout(() => {
            callbackfn(locale, callbackparam);
          }, 300);
        }
      })
      .catch(error => {
        console.warn('Request failed', error);
        return error;
      });
  } catch (e) {
    return console.warn(e);
  }
  return null;
}

/**
 * Upload file
 * @param  {Number}   orderNumber
 * @param  {Object}   file
 * @param  {Function} fn
 */
export async function clientUpload(file, locale, fn) {
  const url = `/api/w1/client_uploads.json`;
  const auth = authorizeRequest(null);
  const formData = new FormData();
  formData.append('file', file, file.name);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      // 'Content-Type': 'multipart/form-data',
    },
    body: formData,
  };
  try {
    await createFetch(Options)(url, options)
      .then(result => {
        if (result.status === 200) {
          // add image response to UploadedImageList
          result.json().then(i => {
            if (fn) {
              return fn([i.client_upload]);
            }
          });
        }
      })
      .catch(error => {
        console.warn('Request failed', error);
        return error;
      });
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Upload file
 * @param  {string}   locale // Language
 * @param  {Object}   files
 * @param  {Function} fn // add response to client_uploads
 * @param  {Function} setIsUploadedClientPhoto
 */
export async function asyncUpload(files, locale, fn, setIsUploadedClientPhoto) {
  // ensure uploaded all image
  await Promise.all(
    files
      .filter(f => f.name !== undefined)
      .map(file => clientUpload(file, locale, fn)),
  );
  setTimeout(() => {
    if (setIsUploadedClientPhoto) {
      setIsUploadedClientPhoto(true);
    }
  }, 1000);
}

/**
 * Create order
 * @param  {String} params.vehicle
 * @param  {String} params.service_type
 * @param  {String} params.nickname
 * @param  {String} params.phone_number
 * @param  {String} params.pickup_time
 * @param  {Object} params.waypoints_attributes
 * @param  {Object} params.waypoints_attributes[n].address
 * @param  {Object} params.waypoints_attributes[n].lat
 * @param  {Object} params.waypoints_attributes[n].lon
 */
export async function createOrder(params, locale) {
  const order = params;
  const requiredParams = [
    'vehicle',
    'service_type',
    'nickname',
    'phone_number',
    'pickup_time',
    'waypoints_attributes',
  ];
  const url = `/api/w1/order_requests.json`;

  // check whether is valid order
  for (let i = 0; i < requiredParams.length; i += 1) {
    const name = requiredParams[i];
    if (typeof order[name] === 'undefined') {
      return console.warn(`No ${name} specified`);
    }
  }

  const json = {
    order: params,
  };

  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  };
  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}



// WEBPACK FOOTER //
// ./src/api/order.js